import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, createElementVNode as _createElementVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"

const _withScopeId = n => (_pushScopeId("data-v-74d4f17c"),n=n(),_popScopeId(),n)
const _hoisted_1 = { class: "monitorings__block" }
const _hoisted_2 = { class: "monitorings__header" }

import { ModelThrowComponentsTab, Tab, Tabs } from 'tir-components';
import { computed, onMounted, ref, watch } from 'vue';
import { RouterView, useRouter } from 'vue-router';
import { MonitoringHeader } from './components';
import { MonitoringHeaderFilterModel } from './models';
import GetEmployeesWithAccessToProjectItemModel from './models/GetEmployeesWithAccessToProjectItemModel';
import { MonitoringPagesEnum } from './enums';
import { MonitoringsAdapterService } from './adapter-service';
import GetEmployeesWithAccessToProjectRequestModel from './models/GetEmployeesWithAccessToProjectRequestModel';
import { debounce } from 'tir-pm-debounce';

/**Роутер */

export default /*#__PURE__*/_defineComponent({
  __name: 'monitorings',
  setup(__props) {

const router = useRouter();
/**адаптер */
const adapter = new MonitoringsAdapterService();

/**Первое число текущего месяца с годом */
const firstDayOfMonth = new Date(new Date().getFullYear(), new Date().getMonth(), 1);

/**Текущая дата, месяц и год */
const currentDayOfMonth = new Date();
/**Поиск юзеров */
const searchEmployeesProject = debounce((search: string) => getEmployeesProject(search), 300);
/**Вкладки */
const tabs = ['По дням', 'По тикетам'];
/**Текущая вкладка */
const currentTab = ref<string>();
/**Состояние чекбокса Все мои проекты из локалсторедж */
const stateAllMyProjectsChecked = localStorage.getItem('stateAllMyProjectsChecked');

/**фильтр  */
const filter = ref(
  new MonitoringHeaderFilterModel({
    Search: '',
    SearchPerformers: '',
    SelectedPerformer: {} as GetEmployeesWithAccessToProjectItemModel,
    Performers: [],
    AllMyProjectsChecked: JSON.parse(stateAllMyProjectsChecked) || false,
    TotalWorkTime: 0,
    DateStart: new Date(firstDayOfMonth),
    DateEnd: new Date(currentDayOfMonth),
  }),
);

/**Обновленная начальная дата */
const updateDateStart = computed(() => {
  if (!filter.value.DateStart) return null;

  const startDate = new Date(filter.value.DateStart);
  startDate.setUTCDate(startDate.getUTCDate() + 1);
  startDate.setUTCHours(0, 0, 0, 0);

  return startDate;
});
/**Обновленная конечная дата */
const updateDateEnd = computed(() => {
  if (!filter.value.DateEnd) return null;

  const endDate = new Date(filter.value.DateEnd);
  endDate.setUTCDate(endDate.getUTCDate() + 1);
  endDate.setUTCHours(0, 0, 0, 0);

  return endDate;
});

/**Отслеживание изменения пути */
watch(
  () => router.currentRoute.value.name,
  () => {
    const routerName = router.currentRoute.value.name;
    filter.value.Search = '';
    if (routerName === MonitoringPagesEnum.Days) {
      currentTab.value = String(tabs[0]);
    } else if (routerName === MonitoringPagesEnum.Tickets) {
      currentTab.value = String(tabs[1]);
    }
  },
  { immediate: true },
);

/**После рендера компонента */
onMounted(async () => {
  await getEmployeesProject();
});

/**Выбрать исполнителя */
const selectPerformer = async (performer: GetEmployeesWithAccessToProjectItemModel) => {
  await getEmployeesProject();

  filter.value.Performers = filter.value.Performers.filter(
    (item) => item.UserId !== performer.UserId,
  );
  filter.value.SelectedPerformer = performer;
};
/**Получить исполнителей проекта*/
const getEmployeesProject = async (_search?: string) => {
  const projectId = router.currentRoute.value.params.projectId;
  const response = await adapter.getEmployeesWithAccessToProject(
    new GetEmployeesWithAccessToProjectRequestModel({
      ProjectId: +projectId,
      Search: _search,
    }),
  );
  filter.value.Performers = response.Value.Items;
};
/**Очистить фильтр */
const clearFilter = async () => {
  filter.value.SelectedPerformer = {} as GetEmployeesWithAccessToProjectItemModel;
  await getEmployeesProject();
};

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createElementBlock("div", _hoisted_1, [
    _createElementVNode("div", _hoisted_2, [
      _createVNode(_unref(MonitoringHeader), {
        filter: filter.value,
        selectedDateStart: filter.value.DateStart,
        "onUpdate:selectedDateStart": _cache[0] || (_cache[0] = ($event: any) => ((filter.value.DateStart) = $event)),
        selectedDateEnd: filter.value.DateEnd,
        "onUpdate:selectedDateEnd": _cache[1] || (_cache[1] = ($event: any) => ((filter.value.DateEnd) = $event)),
        searchPerformers: filter.value.SearchPerformers,
        "onUpdate:searchPerformers": [
          _cache[2] || (_cache[2] = ($event: any) => ((filter.value.SearchPerformers) = $event)),
          _unref(searchEmployeesProject)
        ],
        selectPerformer: filter.value.SelectedPerformer,
        "onUpdate:selectPerformer": _cache[3] || (_cache[3] = ($event: any) => ((filter.value.SelectedPerformer) = $event)),
        search: filter.value.Search,
        performers: filter.value.Performers,
        dateStart: filter.value.DateStart,
        dateEnd: filter.value.DateEnd,
        totalWorkTime: filter.value.TotalWorkTime,
        "onUpdate:search": _cache[4] || (_cache[4] = ($event: any) => (filter.value.Search = $event)),
        onSelectPerformer: selectPerformer,
        onClearFilter: clearFilter
      }, null, 8, ["filter", "selectedDateStart", "selectedDateEnd", "searchPerformers", "selectPerformer", "search", "performers", "dateStart", "dateEnd", "totalWorkTime", "onUpdate:searchPerformers"])
    ]),
    _createVNode(_unref(RouterView), {
      filter: filter.value,
      selectDateStart: updateDateStart.value,
      selectDateEnd: updateDateEnd.value
    }, null, 8, ["filter", "selectDateStart", "selectDateEnd"])
  ]))
}
}

})